import React from 'react';
import classnames from 'classnames';

import ModalBackground from '../../../assets/GuestHome/NNL-signup.jpg';
import SubscribeCTAButtonV2 from '../../../components/GuestHomePageComponents/V2Components/SubscribeCTAButtonV2';

import styles from './css/GuestHomePageV2.module.css';


function TourCallToActionModal() {
  return (
    <div className={styles.modalContainer}>
      <img alt="Sign Up To Watch all Naked News Videos" src={ModalBackground} />
      <SubscribeCTAButtonV2
        classNames={classnames(styles.tourCallToActionButton)}
        doNotHide={true}
        link="/account/purchase"
        title="SIGN UP NOW"
      />
    </div>
  );
}

export default TourCallToActionModal;
